export const forBusiness_graphics_create = [
	{
		icon: '🎑',
		title: 'createData_title1',
		subtitle: 'createData_subtitle1',
	},
	{
		icon: '🌈',
		title: 'createData_title2',
		subtitle: 'createData_subtitle2',
	},
	{
		icon: '✨',
		title: 'createData_title3',
		subtitle: 'createData_subtitle3',
	},
	{
		icon: '🖼',
		title: 'createData_title4',
		subtitle: 'createData_subtitle4',
	},
	{
		icon: '✌️',
		title: 'createData_title5',
		subtitle: 'createData_subtitle5',
	},
];
